module.exports = __webpack_public_path__ + "bb88b9742df58bd7c1da0194f049e3bf.MP3";